import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import { RouterProvider } from 'react-router-dom'
import router from './router'
import { Provider } from 'react-redux';
import store from './store';
import 'normalize.css'//样式初始化
import './i18n' //国际化

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>
    //     <Provider store={store}>
    //         <RouterProvider router={router} />
    //     </Provider>
    // </React.StrictMode>,
    <Provider store={store}>
        <script id="tianditumap" src="/utils/tianditu.js" />
        <RouterProvider router={router} />
    </Provider>
);
